module.exports = __webpack_public_path__ + "img/pie-chart.91d623bd.svg";